import { render, staticRenderFns } from "./FulfilledvsDelivered.vue?vue&type=template&id=65a81707"
import script from "./FulfilledvsDelivered.vue?vue&type=script&lang=js"
export * from "./FulfilledvsDelivered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports